export default __webpack_public_path__ + "static/media/Video2.b34e0c56.mov";